import { createContext } from 'react'

export const PropertyDataContext = createContext({
  properties: [],
  allProperties: [],
  loading: true,
  error: null,
  refresh: () => {},
})
